import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'ridango-selectable-checkable-item',
    templateUrl: './selectable-checkable-item.component.html',
    styleUrls: ['./selectable-checkable-item.component.scss']
})
export class SelectableCheckableItemComponent {
    @Input() selected = false;
    @Input() item;
    @Input() locale = null;
    @Input() disabled = false;
    @Input() itemImage = false;
    @Input() plainStringItem = false;
    @Input() tabIndex = 0;
    @Input() useShortName = false;
    @Output() onItemSelected = new EventEmitter<any>();
    @Output() onMovedLeft = new EventEmitter<any>();
    @Output() onMovedRight = new EventEmitter<any>();
    @Output() onFocused = new EventEmitter<any>();
    @Output() onBlurred = new EventEmitter<any>();
    @Input() first = true;
    @Input() customImageUrl: string;

    @ViewChild('selectCheckItem') selectCheckItem: ElementRef;

    itemSelected() {
        if (!this.disabled) {
            this.onItemSelected.emit(this.item);
        }
    }

    movedLeft() {
        if (!this.disabled) {
            this.onMovedLeft.emit(this.item);
        }
    }

    movedRight() {
        if (!this.disabled) {
            this.onMovedRight.emit(this.item);
        }
    }

    focused() {
        if (!this.disabled) {
            this.onFocused.emit(this.item);
        }
    }

    blurred() {
        this.onBlurred.emit(this.item);
    }

    getItemTranslation() {
        if (!this.item.translations) {
            return this.item.name ? this.item.name : '';
        }

        // For wallet products, short name needs to be used (long name is 'Cashin' for all wallet products)
        if (this.useShortName) {
            return this.item.translations.find((t) => {
                return t.lang === this.locale && t.field === 'short_name';
            }) !== undefined
                ? this.item.translations.find((t) => {
                      return t.lang === this.locale && t.field === 'short_name';
                  }).translation
                : this.item.short_name
                  ? this.item.short_name
                  : '-';
        }

        return this.item.translations.find((t) => {
            return t.lang === this.locale;
        }) !== undefined
            ? this.item.translations.find((t) => {
                  return t.lang === this.locale;
              }).translation
            : this.item.name
              ? this.item.name
              : '-';
    }
}
